import React from 'react';
import { UseCases } from '../homepage/UseCases';
import { Footer } from '../homepage/Footer';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import '../pages/static-page.css';

export const UseCasesPage: React.FC = () => (
  <>
    <PageSeo
      path="/use-cases"
      localized
      titleKey="seo.useCases.title"
      descriptionKey="seo.useCases.description"
      ogImage="/og/og-default.png"
      keywords={['react i18n', 'next.js i18n', 'vue i18n', 'mobile localization', 'saas localization']}
      jsonLd={[
        breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Use cases', path: '/use-cases' },
        ]),
      ]}
    />
    <div className="page-wrapper">
      <div style={{ paddingTop: '40px' }}>
        {/* Here the section title *is* the page title; see UseCases' headingLevel. */}
        <UseCases headingLevel={1} />
      </div>
      <Footer />
    </div>
  </>
);
